import { ReactElement } from 'react';
import FormGroup from '~/components/form/FormGroup';
import { FormHorizontal } from '~/components/form/layout';
import ValibotFieldInput from '~/components/valibot/ValibotFieldInput';
import ValibotFieldCheckbox from '~/components/valibot/ValibotFieldCheckbox';

export default function BrePhotosSubmit(): ReactElement {
  return (
    <FormGroup>
      <FormHorizontal name="ai_edit" label="Submit for AI Editing">
        <ValibotFieldCheckbox name="ai_edit" />
      </FormHorizontal>
      <FormHorizontal name="editing_credits" label="Editing Credits">
        <ValibotFieldInput name="editing_credits" type="number" />
      </FormHorizontal>
      <FormHorizontal name="extra_photos" label="Extra Photos">
        <ValibotFieldInput name="extra_photos" type="number" />
      </FormHorizontal>
    </FormGroup>
  );
}
